import getLang from 'I18n/utils/getLang';
import { useState, useCallback, useRef } from 'react';
import localeContext from '../../context/localeContext';
import { useLocaleQueryParams } from '../../hooks/useLocaleQueryParams';
import { captureException } from '../../utils/captureException';
import { loadLocale, toSupportedLocale } from '../../utils/setupI18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const LocaleProvider = ({
  children
}) => {
  const {
    localeQueryParam,
    updateLocaleQueryParam
  } = useLocaleQueryParams();
  const getInitialLocale = useCallback(() => {
    if (localeQueryParam) {
      return toSupportedLocale(localeQueryParam);
    }
    // Otherwise get current lang from language provider, which should be the users browser locale
    const browserLocale = getLang();
    return toSupportedLocale(browserLocale);
  }, [localeQueryParam]);
  const [locale, setLocale] = useState(getInitialLocale());
  const requestedLocaleRef = useRef(locale);
  const updateLocale = useCallback(newLocale => {
    // Only the active locale's translations are loaded, so a language change
    // has to fetch the new locale's chunk before switching — otherwise the
    // form would flash English while the chunk is in flight. The ref keeps
    // the most recent selection winning if a user switches twice quickly.
    requestedLocaleRef.current = newLocale;
    const switchLocale = async () => {
      try {
        await loadLocale(newLocale);
      } catch (error) {
        // Switch anyway: untranslated keys fall back to English, which beats
        // leaving the select stuck on the previous language.
        captureException(error, ['locale-load-failed']);
      }
      if (requestedLocaleRef.current !== newLocale) {
        return;
      }
      setLocale(newLocale);
      updateLocaleQueryParam(newLocale);
    };
    void switchLocale();
  }, [updateLocaleQueryParam]);
  return /*#__PURE__*/_jsx(localeContext.Provider, {
    value: {
      locale,
      updateLocale
    },
    children: children
  });
};